<template>
  <v-card class="reference-card-skeleton-loader">
    <div class="left-panel flex-grow-1 px-4 py-3">
      <v-skeleton-loader class="title" type="text" />
      <v-skeleton-loader class="subtitle" type="text" />
      <div class="d-flex align-center">
        <v-skeleton-loader class="mr-3 chip" type="chip" />
        <v-skeleton-loader class="mr-3" type="button" />
      </div>
    </div>
    <div class="d-flex py-3">
      <v-skeleton-loader class="mr-3" type="button" />
      <v-skeleton-loader class="mr-3" type="button" />
      <v-skeleton-loader class="mr-3" type="button" />
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'ReferenceCardSkeletonLoader',
};
</script>

<style lang="scss" scoped>
.reference-card-skeleton-loader {
  display: flex;
  justify-content: space-between;

  .left-panel {
    display: grid;
    gap: 12px;
  }

  .title {
    max-width: 500px;
  }
  .subtitle {
    max-width: 400px;
  }
}
</style>

<style lang="scss">
.reference-card-skeleton-loader {
  .v-skeleton-loader__chip {
    width: 100px;
    height: 24px;
  }
  .v-skeleton-loader__button {
    width: 63px;
    height: 24px;
  }
}
</style>
